// import logo from './logo.svg';
import React, { useState } from 'react'
import './App.css';
import Navbar from './components/Navigation/Navbar';
import { Link } from 'react-scroll';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Modal from 'react-modal';
import emailjs from 'emailjs-com';
import { BrowserRouter as Router, Routes, Route, Link as RouterLink } from 'react-router-dom';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';

// import banner from '../src/assets/banner.mp4'
import art from '../src/assets/art.png'
import art2 from '../src/assets/art2.png'

Modal.setAppElement('#root')

function HomePage() {
  return (
    <div className="App">
      <Navbar />

      <section className='home' id='home'>
       <div className="wrapper">
        <div className='motto-container'>
          <span className='motto'>Seamless <span className='support'>Support</span> for <br/> Seamless <span className='success'>Success</span>.</span>
          <span className='sub-motto'>Virtual Assistant and Technical Support</span>
          <div className='cto'>
            <a href="#contact" className="button">Request Demo</a>
          </div>
        </div>
       </div>
      </section>

      <section className='services' id='services'>
        <div className="wrapper">
          <span className='title'>Services</span>
          <div className='services-container'>
            <div className='each-service'>
              <svg width="50" height="50" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M39.9997 71.2825V67.9483H61.2813C61.8797 67.9483 62.3713 67.7561 62.7563 67.3717C63.1408 66.9872 63.333 66.4958 63.333 65.8975V63.3333H53.0763V42.8208H63.333V36.6667C63.333 30.2222 61.0552 24.7222 56.4997 20.1667C51.9441 15.6111 46.4441 13.3333 39.9997 13.3333C33.5552 13.3333 28.0552 15.6111 23.4997 20.1667C18.9441 24.7222 16.6663 30.2222 16.6663 36.6667V42.8208H26.923V63.3333H18.718C17.1836 63.3333 15.9025 62.8194 14.8747 61.7917C13.8469 60.7639 13.333 59.4828 13.333 57.9483V36.6667C13.333 32.9828 14.0286 29.5244 15.4197 26.2917C16.8108 23.0589 18.7177 20.2308 21.1405 17.8075C23.5638 15.3847 26.3919 13.4778 29.6247 12.0867C32.8575 10.6956 36.3158 10 39.9997 10C43.6836 10 47.1419 10.6956 50.3747 12.0867C53.6074 13.4778 56.4355 15.3847 58.8588 17.8075C61.2816 20.2308 63.1886 23.0589 64.5797 26.2917C65.9708 29.5244 66.6663 32.9828 66.6663 36.6667V65.8975C66.6663 67.4314 66.1524 68.7122 65.1247 69.74C64.0969 70.7683 62.8158 71.2825 61.2813 71.2825H39.9997ZM18.718 60H23.5897V46.1542H16.6663V57.9483C16.6663 58.5467 16.8586 59.0383 17.243 59.4233C17.628 59.8078 18.1197 60 18.718 60ZM56.4097 60H63.333V46.1542H56.4097V60ZM18.718 46.1542H16.6663H23.5897H18.718Z" fill="black"/>
              </svg>
              <div className='service-name'>Virtual Assistance</div>
              <div>Experience efficiency with our Virtual Assistant service. Streamline tasks, enhance productivity, and focus on growth. Your personal champion in business support.</div>
            </div>
            <div className='each-service'>
              <svg width="50" height="50" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.10254 67.1792V10.5125H39.1025V23.8458H70.8975V67.1792H9.10254ZM12.4359 63.8458H35.7692V53.8458H12.4359V63.8458ZM12.4359 50.5125H35.7692V40.5125H12.4359V50.5125ZM12.4359 37.1792H35.7692V27.1792H12.4359V37.1792ZM12.4359 23.8458H35.7692V13.8458H12.4359V23.8458ZM39.1025 63.8458H67.5642V27.1792H39.1025V63.8458ZM47.0517 40.5125V37.1792H58.3334V40.5125H47.0517ZM47.0517 53.8458V50.5125H58.3334V53.8458H47.0517Z" fill="black"/>
              </svg>
              <div className='service-name'>Back Office Support</div>
              <div>Optimize operations with our Back Office Support Service. Streamlined processes, efficient data management, and reliable assistance for business success.</div>
            </div>
            <div className='each-service'>
              <svg width="50" height="50" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M33.7819 70L32.5769 60.3592C31.513 60.0386 30.3624 59.5342 29.1252 58.8458C27.888 58.1581 26.8358 57.4211 25.9685 56.635L17.0769 60.4167L10.8594 49.5833L18.5452 43.7883C18.4469 43.1861 18.3658 42.5656 18.3019 41.9267C18.2374 41.2878 18.2052 40.6669 18.2052 40.0642C18.2052 39.5042 18.2374 38.9156 18.3019 38.2983C18.3658 37.6806 18.4469 36.985 18.5452 36.2117L10.8594 30.4167L17.0769 19.7117L25.9044 23.4292C26.8999 22.6003 27.9769 21.8525 29.1352 21.1858C30.293 20.5192 31.4188 20.0042 32.5127 19.6408L33.7819 10H46.2185L47.4235 19.705C48.7013 20.1539 49.8305 20.6689 50.811 21.25C51.7916 21.8311 52.8013 22.5575 53.8402 23.4292L62.9235 19.7117L69.141 30.4167L61.1985 36.4042C61.3824 37.0919 61.4852 37.7233 61.5069 38.2983C61.528 38.8728 61.5385 39.44 61.5385 40C61.5385 40.5172 61.5172 41.0631 61.4744 41.6375C61.4316 42.2125 61.3333 42.9081 61.1794 43.7242L68.9935 49.5833L62.776 60.4167L53.8402 56.5708C52.8013 57.4425 51.7563 58.1903 50.7052 58.8142C49.6541 59.4381 48.5602 59.9317 47.4235 60.295L46.2185 70H33.7819ZM36.6669 66.6667H43.186L44.4169 57.6408C46.0963 57.1964 47.608 56.5864 48.9519 55.8108C50.2963 55.0353 51.6649 53.9722 53.0577 52.6217L61.3719 56.1667L64.686 50.5L57.391 45.0192C57.6688 44.0703 57.8527 43.1975 57.9427 42.4008C58.0322 41.6036 58.0769 40.8033 58.0769 40C58.0769 39.1539 58.0322 38.3536 57.9427 37.5992C57.8527 36.8453 57.6688 36.0153 57.391 35.1092L64.8144 29.5L61.5002 23.8333L52.9935 27.3975C51.9852 26.2908 50.6594 25.2533 49.016 24.285C47.3733 23.3172 45.8188 22.6753 44.3527 22.3592L43.3335 13.3333H36.686L35.6477 22.295C33.9683 22.6539 32.4244 23.2319 31.016 24.0292C29.6083 24.8258 28.2077 25.9208 26.8144 27.3142L18.5002 23.8333L15.186 29.5L22.4169 34.8975C22.1391 35.6453 21.9447 36.4572 21.8335 37.3333C21.7224 38.2094 21.6669 39.1197 21.6669 40.0642C21.6669 40.9103 21.7224 41.75 21.8335 42.5833C21.9447 43.4167 22.1177 44.2286 22.3527 45.0192L15.186 50.5L18.5002 56.1667L26.7502 52.6667C28.058 53.9872 29.4158 55.0461 30.8235 55.8433C32.2319 56.64 33.8185 57.2606 35.5835 57.705L36.6669 66.6667ZM39.9102 48.3333C42.2352 48.3333 44.2055 47.5256 45.821 45.91C47.436 44.295 48.2435 42.325 48.2435 40C48.2435 37.675 47.436 35.705 45.821 34.09C44.2055 32.4744 42.2352 31.6667 39.9102 31.6667C37.573 31.6667 35.5997 32.4744 33.9902 34.09C32.3813 35.705 31.5769 37.675 31.5769 40C31.5769 42.325 32.3813 44.295 33.9902 45.91C35.5997 47.5256 37.573 48.3333 39.9102 48.3333Z" fill="black"/>
              </svg>
              <div className='service-name'>Technical Support</div>
              <div>Enhance your tech experience with our Technical Support Service. Expert assistance, quick resolutions, and 24/7 availability for seamless operations.</div>
            </div>
          </div>
          <div className='services-process'>
            <span className='process-title'>Our Process</span>
            <div className='process-container'>
              <div className='each-process'>
                <span className='num'>1</span>
                <span className='heading'>Arrange an Initial meeting</span>
                <span className='text'>To initiate the process, you'll participate in a brief conference call with your assistant's project manager and trainer to finalize the details.</span>
              </div>
              <div className='each-process'>
                <span className='num'>2</span>
                <span className='heading'>Meet Your Virtual Assistant</span>
                <span className='text'>We understand the significance of finding the perfect match for your business. Feel free to interview as many assistants as needed until you discover the one that resonates with you.</span>
              </div>
              <div className='each-process'>
                <span className='num'>3</span>
                <span className='heading'>Relax and Enjoy Results</span>
                <span className='text'>Relax and focus on what matters. Your virtual assistant handles daily tasks, ensuring everything runs smoothly and efficiently with your customized plan in action.</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='about' id='about'>
        <div className="wrapper">
          <span className='title white-title'>About</span>
          <div className='about-container'>
            <div className='about-text'>
              Deutsche Business Solutions, Inc. is a team of seasoned experts with a strong foundation in collaborating with Filipino Virtual Assistants.
              <a href="#contact" className="button">Request Demo</a>
            </div>
            <div className='about-art-container'>
              <img className='about-art' src={art} alt="About" />
            </div>
          </div>
        </div>
      </section>

      <section className='contact' id='contact'>
        <div className="wrapper">
          <span className='title white-title'>Contact</span> <br/>
          <span className='contact-title'>Book Your Appointment</span>
          <div className='contact-container'>
            <div className='contact-art'>
              <img src={art2} alt="Contact" />
            </div>
            <div className='contact-form'>
              <div className='form-container'>
                <form name="dbs" method="POST" netlify>
                  <input type="hidden" name="form-name" value="contact" />
                  <input required type="text" name="name" placeholder="Name" />
                  <input required type="text" name="company-name" placeholder="Company Name" />
                  <input required type="email" name="email" placeholder="Email" />
                  <textarea required name="message" cols="10" rows="10" placeholder="Message"/>
                  <div data-netlify-recaptcha="true"></div>
                  <button className='contact-btn' type="submit">Book Now</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="footer">
        <div className="wrapper">
          <div className="grid-footer">
            <div className="footer-right"></div>
            <div className="footer-left">
              <span>© 2026 Deutsche Business Solutions, Inc.</span>
              <span>Site developed by 
                <a target="_blank" rel="noopener noreferrer" href="https://design.jinsgonzales.com"> Jins Gonzales Design</a>
              </span>
              <span>
                <RouterLink to="/terms-and-conditions" className="footer-link">Terms and Conditions</RouterLink>
                {' • '}
                <RouterLink to="/privacy-policy" className="footer-link">Privacy Policy</RouterLink>
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;